import { render, staticRenderFns } from "./editRootDialog.vue?vue&type=template&id=dd594fd8&scoped=true&"
import script from "./editRootDialog.vue?vue&type=script&lang=js&"
export * from "./editRootDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd594fd8",
  null
  
)

export default component.exports